import { TaxConfigurationDeductions } from './configuration';
import { License } from './licenses';
import { PaymentFees } from './payment';

/** Model for The way Tax State is Handled */
export interface TaxState {
  isGetTaxPaymentPeriodsInProgress: boolean;
  isTaxPaymentPeriodsSuccess: boolean;
  taxPaymentPeriods: string[] | string;
  taxPaymentPeriodsErrorMsg: string;

  isCalculateTaxInProgress: boolean;
  isCalculateTaxSuccess: boolean;
  calculatedTaxData: unknown; // raw data returned from  /calculateMultiPropertyTot
  calculatedTaxErrorMsg: string;

  preSelectedPeriod?: Period;

  taxFlowData: TaxFlowData;
  taxSteps?: unknown;
}

export interface PeriodLicense extends License {
  address: string;
  buckets?: Array<RevenueReport>;
  occupancy?: OccupancyReport;
  ownerName: string;
  selected: boolean;
  totPaidStatus: 'complete' | 'incomplete';
}

export interface PaymentPeriod extends Period {
  year: number;
  label: string;
  selected: boolean;
  licenses: Array<PeriodLicense>;
  id: string;
  quarter?: number; // used to identify the quarter in Quarterly Periods
}

export enum ReportingMethod {
  INDIVIDUAL = 'individual',
  BULK = 'bulk',
}

export interface TaxFlowData {
  selectedLicenses: Array<PaymentPeriod>;
  reportingMethod?: ReportingMethod;
}

export interface Period {
  startDate: string;
  endDate: string;
}

/** Collection Agreement Data */

export interface BucketData extends CollectionAgreementBucket {
  deductionsConfig: TaxConfigurationDeductions;
}
export interface CollectionAgreementBucket {
  key: string;
  label: string;
  collected_taxes: string[];
}

export interface CollectionAgreementBucketWith {
  [date: string]: {
    buckets: CollectionAgreementBucket[];
  };
}

export interface CollectionAgreementBucketConfig {
  enable: boolean;
  with: CollectionAgreementBucketWith;
}

export interface RevenueReport {
  discounts?: number;
  revenue?: number;
  provider?: string;
}

export interface OccupancyReport {
  available?: number;
  occupied?: number;
}

export interface TaxReportLicense {
  buckets: Array<RevenueReport>;
  occupancy: OccupancyReport;
}

export interface TaxPeriod {
  licenses: Array<TaxReportLicense>;
}

export interface TaxDataModel {
  periods?: Array<TaxPeriod>;
}

export interface BucketError {
  discounts?: string;
  revenue?: string;
}

export interface OccupancyError {
  available?: string;
  occupied?: string;
}

export interface TaxLicenseError {
  buckets: Array<BucketError>;
  occupancy: OccupancyError;
}

export interface TaxPeriodError {
  licenses: Array<TaxLicenseError>;
}

export interface TaxDataError {
  periods?: Array<TaxPeriodError>;
}

export interface TaxableReceipt extends Record<string, number | undefined> {
  accruedInterest: number;
  latePenalties: number;
  total: number;
  totDue: number;
  credit?: number;
}

export interface TaxableActivity {
  deductions: number;
  key: string;
  sales: number;
  taxableReceipts: number;
  taxTypes: Record<string, TaxableReceipt>;
}

export interface CalculatedTotMisc {
  taxableActivities: Array<TaxableActivity>;
}

export interface CalculatedTotDetail {
  misc: CalculatedTotMisc;
}
export interface CalculatedTot extends PaymentFees {
  paymentId?: string;
  details: Array<CalculatedTotDetail>;
}
